import {
  ButtonLink,
  FontIcons,
  Placements,
  ButtonLooks,
  DropdownLooks,
  StandardDropdownProps
} from '@brandfolder/react';
import { FunctionComponent, useContext } from 'react';
import styled from 'styled-components';

import { OAuthContext } from '@context/oauth';

import { HeaderDropdown } from './header-dropdown';

interface HeaderLoggedInAsProps extends Partial<StandardDropdownProps> {}

const UnstyledHeaderLoggedInAs: FunctionComponent<HeaderLoggedInAsProps> = (props) => {
  const { user } = useContext(OAuthContext);

  const getUserName = (): string => {
    if (user?.first_name) {
      return user?.first_name;
    }
    if (user?.email) {
      return user.email.split('@')[0];
    }
    return 'User';
  };

  return (
    <HeaderDropdown
      {...props}
      buttonProps={{
        startIcon: FontIcons.Person
      }}
      id="header-logged-in-as"
      listItems={[
        {
          children: (
            <ButtonLink href="/sign-out" look={ButtonLooks.Default} startIcon={FontIcons.CheckOut}>
              Sign Out
            </ButtonLink>
          ),
          key: 'signout'
        }
      ]}
      look={DropdownLooks.Default}
      placement={Placements.BottomEnd}
    >
      {getUserName()}
    </HeaderDropdown>
  );
};

const StyledHeaderLoggedInAs = styled(UnstyledHeaderLoggedInAs)``;

export const HeaderLoggedInAs: FunctionComponent<HeaderLoggedInAsProps> = (props) => {
  return <StyledHeaderLoggedInAs {...props} />;
};
